import { createApp } from "vue";
import App from "./App.vue";
import router from "router";
import Vant from "vant";
import "vant/lib/index.css";
import "styles/index.js";
// 实现移动端的转换
import "amfe-flexible";
import * as tool from "./utils/index";
import store from "store/index.js";

import "xe-utils";
import eventBus from "vue3-eventbus";

// 导入多语言配置
import i18n from "./lang";

// import VideoPlayer from "vue-video-player";
// import "video.js/dist/video-js.css";
// import "vue-video-player/src/custom-theme.css";

const app = createApp(App);
app.config.globalProperties.Tool = tool;

// 全局注册自有组件

// 自定义滚动条实现
class CustomScrollbar {
  constructor() {
    this.scrollbar = null;
    this.scrollThumb = null;
    this.scrollTimer = null;
    this.isDragging = false;
    this.dragStart = 0;
    this.scrollStart = 0;

    this.init();
  }

  init() {
    // 隐藏原生滚动条
    this.hideNativeScrollbar();

    // 创建自定义滚动条
    this.createScrollbar();

    // 绑定事件
    this.bindEvents();
  }

  hideNativeScrollbar() {
    const style = document.createElement("style");
    style.textContent = `
      /* 隐藏原生滚动条 */
      ::-webkit-scrollbar {
        width: 0px;
        background: transparent;
      }
      
      body {
        scrollbar-width: none;
        -ms-overflow-style: none;
      }
    `;
    document.head.appendChild(style);
  }

  createScrollbar() {
    // 创建滚动条容器
    this.scrollbar = document.createElement("div");
    this.scrollbar.className = "custom-scrollbar";
    this.scrollbar.style.cssText = `
      position: fixed;
      top: 0;
      right: 1px;
      width: 4px;
      height: 100vh;
      background: transparent;
      z-index: 9999;
      opacity: 0;
      transition: opacity 0.3s ease;
      pointer-events: none;
    `;

    // 创建滚动条滑块
    this.scrollThumb = document.createElement("div");
    this.scrollThumb.className = "custom-scrollbar-thumb";
    this.scrollThumb.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      background: rgba(115, 115, 115, 0.7);
      border-radius: 4px;
      cursor: pointer;
      transition: background-color 0.2s ease;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    `;

    this.scrollbar.appendChild(this.scrollThumb);
    document.body.appendChild(this.scrollbar);

    // 移动端适配
    if (window.innerWidth <= 768) {
      this.scrollbar.style.width = "3px";
      this.scrollThumb.style.borderRadius = "3px";
    }
  }

  updateScrollbar() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (scrollHeight <= clientHeight) {
      this.scrollbar.style.opacity = "0";
      return;
    }

    // 计算滑块高度和位置
    const thumbHeight = Math.max(
      30,
      (clientHeight / scrollHeight) * clientHeight
    );
    const thumbTop =
      (scrollTop / (scrollHeight - clientHeight)) *
      (clientHeight - thumbHeight);

    this.scrollThumb.style.height = thumbHeight + "px";
    this.scrollThumb.style.top = thumbTop + "px";
  }

  showScrollbar() {
    this.scrollbar.style.opacity = "1";
    this.scrollbar.style.pointerEvents = "auto";

    clearTimeout(this.scrollTimer);
    this.scrollTimer = setTimeout(() => {
      this.hideScrollbar();
    }, 1000);
  }

  hideScrollbar() {
    if (!this.isDragging) {
      this.scrollbar.style.opacity = "0";
      this.scrollbar.style.pointerEvents = "none";
    }
  }

  bindEvents() {
    // 滚动事件
    window.addEventListener(
      "scroll",
      () => {
        this.updateScrollbar();
        this.showScrollbar();
      },
      { passive: true }
    );

    // 窗口大小变化
    window.addEventListener("resize", () => {
      this.updateScrollbar();

      // 移动端适配
      if (window.innerWidth <= 768) {
        this.scrollbar.style.width = "3px";
        this.scrollThumb.style.borderRadius = "3px";
      } else {
        this.scrollbar.style.width = "4px";
        this.scrollThumb.style.borderRadius = "4px";
      }
    });

    // 滑块悬停效果
    this.scrollThumb.addEventListener("mouseenter", () => {
      this.scrollThumb.style.backgroundColor = "rgba(115, 115, 115, 0.9)";
    });

    this.scrollThumb.addEventListener("mouseleave", () => {
      if (!this.isDragging) {
        this.scrollThumb.style.backgroundColor = "rgba(115, 115, 115, 0.7)";
      }
    });

    // 滑块拖拽功能
    this.scrollThumb.addEventListener("mousedown", (e) => {
      this.isDragging = true;
      this.dragStart = e.clientY;
      this.scrollStart =
        window.pageYOffset || document.documentElement.scrollTop;

      document.addEventListener("mousemove", this.handleDrag.bind(this));
      document.addEventListener("mouseup", this.handleDragEnd.bind(this));

      e.preventDefault();
    });

    // 轨道点击跳转
    this.scrollbar.addEventListener("click", (e) => {
      if (e.target === this.scrollbar) {
        const rect = this.scrollbar.getBoundingClientRect();
        const clickPosition = (e.clientY - rect.top) / rect.height;
        const scrollHeight = document.documentElement.scrollHeight;
        const clientHeight = document.documentElement.clientHeight;
        const targetScroll = clickPosition * (scrollHeight - clientHeight);

        window.scrollTo({
          top: targetScroll,
          behavior: "smooth",
        });
      }
    });

    // 移动端触摸支持
    let touchStartY = 0;
    let touchEndY = 0;

    window.addEventListener(
      "touchstart",
      (e) => {
        touchStartY = e.touches[0].clientY;
      },
      { passive: true }
    );

    window.addEventListener(
      "touchmove",
      (e) => {
        touchEndY = e.touches[0].clientY;
        if (Math.abs(touchEndY - touchStartY) > 10) {
          this.updateScrollbar();
          this.showScrollbar();
        }
      },
      { passive: true }
    );

    // 初始化时更新一次
    this.updateScrollbar();
  }

  handleDrag(e) {
    if (!this.isDragging) return;

    const deltaY = e.clientY - this.dragStart;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    const scrollRatio = deltaY / clientHeight;
    const targetScroll =
      this.scrollStart + scrollRatio * (scrollHeight - clientHeight);

    window.scrollTo(
      0,
      Math.max(0, Math.min(scrollHeight - clientHeight, targetScroll))
    );
  }

  handleDragEnd() {
    this.isDragging = false;
    this.scrollThumb.style.backgroundColor = "rgba(115, 115, 115, 0.7)";

    document.removeEventListener("mousemove", this.handleDrag.bind(this));
    document.removeEventListener("mouseup", this.handleDragEnd.bind(this));

    // 延迟隐藏滚动条
    clearTimeout(this.scrollTimer);
    this.scrollTimer = setTimeout(() => {
      this.hideScrollbar();
    }, 1000);
  }
}

// 初始化自定义滚动条
document.addEventListener("DOMContentLoaded", () => {
  new CustomScrollbar();
});

app.use(router).use(store).use(Vant).use(eventBus).use(i18n).mount("#app");
